import { Col, Dropdown, Row, Text } from 'components';
import React, { useEffect } from 'react';
import { ValueInput } from 'screens/Admin/components';

const options = [
  {
    value: 'Scheduled',
    opt: 'scheduled'
  },
  {
    value: 'In Play',
    opt: 'in-play'
  },
  {
    value: 'Finished',
    opt: 'finished'
  },
  {
    value: 'Postponed',
    opt: 'postponed'
  },
  {
    value: 'Canceled',
    opt: 'canceled'
  },
  {
    value: 'Abandoned',
    opt: 'abandoned'
  },
  {
    value: 'Not Played',
    opt: 'not-played'
  }
];

const Status = ({ status, setStatus, progress, setProgress, data, gameStatus, setGameStatus }) => {
  useEffect(() => {
    const foundStatus = options.find((x) => x.opt === data.status);
    setProgress(data.progress);
    setGameStatus(data.gameStatus);
    setStatus(foundStatus);
  }, []);

  return (
    <React.Fragment>
      <Dropdown
        title="Status"
        admin
        rounded
        wid="100%"
        placeholder="Select..."
        bg="#fff"
        options={options}
        handleSelect={setStatus}
        selected={status}
      />

      {status?.opt === 'in-play' && (
        <Col>
          <Text b2 med marg="24px 16px 4px">
            Progress
          </Text>

          <Row noFlex start center marg="0 0 0 16px">
            {data.sport === 'basketball' ? (
              <ValueInput
                placeholder="Period, eg: Q1"
                value={gameStatus}
                onChange={(e) => setGameStatus(e.target.value)}
              />
            ) : (
              <ValueInput
                wid="70px"
                placeholder="Minute, eg: 14"
                value={progress}
                onChange={(e) => setProgress(e.target.value)}
              />
            )}
          </Row>
        </Col>
      )}
    </React.Fragment>
  );
};

export default Status;
